import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment'

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    // Получаем значение companyId из localStorage
    const companyId = localStorage.getItem('companyId');

    // Проверяем, что запрос отправляется на нужный домен
    if (!request.url.includes('auth0') && !request.url.includes('owler.com')) {
      // Сохраняем старые заголовки
      //const oldHeaders = request.headers;

      // Если companyId есть, добавляем заголовок X-Company-Id
      if (companyId) {
        request = request.clone({
          headers: request.headers.set('X-Company-Id', companyId)
        });
      } else {
        // Если companyId отсутствует, удаляем заголовок X-Company-Id
        request = request.clone({
          headers: request.headers.delete('X-Company-Id')
        });
      }

      // Продолжаем обработку запроса
      return next.handle(request).pipe(
        tap(() => {
          // if (companyId) {
          //   // Восстанавливаем старые заголовки
          //   request = request.clone({ headers: oldHeaders });
          //   localStorage.removeItem('companyId');
          // }
        })
      );
    } else {
      // Если запрос отправляется на другой домен, просто продолжаем обработку без добавления заголовка
      return next.handle(request);
    }
  }
}

